// 正規化応答(related バケット)を id 結合でネスト形へ復元するための共通プリミティブ。
// サーバー側の汎用ノーマライザ(api: utils/normalizeInclude.ts)と対になるユーティリティで、
// どのルートの正規化応答でも「mapById で単一参照、groupBy で hasMany 参照」を組み立てられる。
import { required } from "../typed";

// id → 行 の索引。belongsTo(単一ネスト)の復元に使う
export function mapById<T extends { id: string | number }>(rows: T[]): Map<T["id"], T> {
  return new Map(rows.map((row) => [row.id, row]));
}

// related.Users(Group 分離済みの平坦行)と related.Groups を id 結合し、従来ネスト形の
// User(Group 込み)へ復元した id 索引を作る。全ハイドレータ(材料検索・発行・利用者)で共有する。
// 所属グループが related に無い行はデータ不整合として明示的に失敗させる(required)。
export function usersWithGroupOf<TUser extends { id: string; group_id: string; name: string }, TGroup extends { id: string }>(users: TUser[], groups: TGroup[]): Map<string, TUser & { Group: TGroup }> {
  const groupById = mapById(groups);
  return mapById(
    users.map((user) => ({
      ...user,
      Group: required(groupById.get(user.group_id), `ユーザー(${user.name})の所属グループ(${user.group_id})`),
    }))
  );
}

// 外部キー → 行配列 の索引。hasMany(配列ネスト)の復元に使う
export function groupBy<T, K>(rows: T[], keyOf: (row: T) => K): Map<K, T[]> {
  const map = new Map<K, T[]>();
  for (const row of rows) {
    const key = keyOf(row);
    const list = map.get(key) ?? [];
    list.push(row);
    map.set(key, list);
  }
  return map;
}
